/**
 * Notifications API Service
 */

import { api, unwrap } from './api';

export interface Notification {
  id: string;
  user_id: string;
  type: string;
  title: string;
  message: string;
  data: Record<string, any>;
  is_read: boolean;
  created_at: string;
}

/**
 * Get notifications for current user
 */
export async function getNotifications(
  limit: number = 50,
  unreadOnly: boolean = false
): Promise<Notification[]> {
  const params = new URLSearchParams({
    limit: limit.toString(),
    unread_only: unreadOnly.toString(),
  });

  return unwrap(await api.get<Notification[]>(`/api/notifications?${params}`));
}

/**
 * Mark notification as read
 */
export async function markNotificationAsRead(notificationId: string): Promise<Notification> {
  return unwrap(await api.post<Notification>(`/api/notifications/${notificationId}/read`, {}));
}

/**
 * Dismiss (delete) notification
 */
export async function dismissNotification(notificationId: string): Promise<void> {
  unwrap(await api.delete(`/api/notifications/${notificationId}`));
}
